import { render, staticRenderFns } from "./RecepcionarTarimaComponent.vue?vue&type=template&id=e0f2071e&"
import script from "./RecepcionarTarimaComponent.vue?vue&type=script&lang=js&"
export * from "./RecepcionarTarimaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports